import React from "react";

import WorkOrderSelectRender, { renderValue } from "./WorkOrderSelectRender";
import { StyledSelect } from "./styles";

const WorkOrderSelectField = ({ options, ...rest }) => {
  return (
    <StyledSelect
      RenderComponent={WorkOrderSelectRender}
      renderValue={(value) => renderValue(value, options)}
      options={options}
      {...rest}
    />
  );
};

export default WorkOrderSelectField;
